<template>
    <div class="payment">
        <button @click="interceptor(topUp)">
            <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.2122 14.8958H10.4889C9.26969 14.8958 8.27051 13.8691 8.27051 12.6041C8.27051 12.2283 8.58217 11.9166 8.95801 11.9166C9.33384 11.9166 9.64551 12.2283 9.64551 12.6041C9.64551 13.1083 10.0214 13.5208 10.4889 13.5208H12.2122C12.5697 13.5208 12.8538 13.2 12.8538 12.8058C12.8538 12.3108 12.7164 12.2375 12.4047 12.1275L9.64551 11.165C9.05884 10.9541 8.27051 10.5325 8.27051 9.18497C8.27051 8.03914 9.17802 7.09497 10.2872 7.09497H12.0105C13.2297 7.09497 14.2288 8.12164 14.2288 9.38664C14.2288 9.76247 13.9172 10.0741 13.5413 10.0741C13.1655 10.0741 12.8538 9.76247 12.8538 9.38664C12.8538 8.88247 12.478 8.46997 12.0105 8.46997H10.2872C9.92969 8.46997 9.64551 8.7908 9.64551 9.18497C9.64551 9.67997 9.783 9.75329 10.0947 9.86329L12.8538 10.8258C13.4405 11.0366 14.2288 11.4583 14.2288 12.8058C14.2288 13.9608 13.3213 14.8958 12.2122 14.8958Z" fill="white"/>
              <path d="M11.25 15.8125C10.8742 15.8125 10.5625 15.5008 10.5625 15.125V6.875C10.5625 6.49917 10.8742 6.1875 11.25 6.1875C11.6258 6.1875 11.9375 6.49917 11.9375 6.875V15.125C11.9375 15.5008 11.6258 15.8125 11.25 15.8125Z" fill="white"/>
              <path d="M11.2497 20.8541C5.81384 20.8541 1.39551 16.4358 1.39551 11C1.39551 5.56415 5.81384 1.14581 11.2497 1.14581C11.6255 1.14581 11.9372 1.45748 11.9372 1.83331C11.9372 2.20915 11.6255 2.52081 11.2497 2.52081C6.57467 2.52081 2.77051 6.32498 2.77051 11C2.77051 15.675 6.57467 19.4791 11.2497 19.4791C15.9247 19.4791 19.7288 15.675 19.7288 11C19.7288 10.6241 20.0405 10.3125 20.4163 10.3125C20.7922 10.3125 21.1038 10.6241 21.1038 11C21.1038 16.4358 16.6855 20.8541 11.2497 20.8541Z" fill="white"/>
              <path d="M15.8353 2.06258C16.2111 2.06258 16.5228 2.37425 16.5228 2.75008V5.72925H19.502C19.8778 5.72925 20.1895 6.04091 20.1895 6.41675C20.1895 6.79258 19.8778 7.10425 19.502 7.10425H15.8353C15.4595 7.10425 15.1478 6.79258 15.1478 6.41675V2.75008C15.1478 2.37425 15.4595 2.06258 15.8353 2.06258Z" class="accent-fill" fill="#C7FF24"/>
              <path d="M15.8356 7.10185C15.6614 7.10185 15.4873 7.03769 15.3498 6.90019C15.0839 6.63435 15.0839 6.19436 15.3498 5.92852L19.9331 1.34519C20.1989 1.07935 20.6389 1.07935 20.9048 1.34519C21.1706 1.61102 21.1706 2.05102 20.9048 2.31685L16.3214 6.90019C16.1839 7.03769 16.0098 7.10185 15.8356 7.10185Z" class="accent-fill" fill="#C7FF24"/>
            </svg>
            <span>{{text('payment.topup_btn')}}</span>
        </button>
        <button @click="interceptor(toExchange)">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 5.05957H22.5" stroke="white" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2.5 17.0596H12.5" stroke="white" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M22.5 13.5C22.5 17.37 19.37 20.5 15.5 20.5M15.5 20.5L16.55 18.75M15.5 20.5L17 22"  class="accent-stroke" stroke="#C7FF24" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2.5 10.5C2.5 6.63 5.63 3.5 9.5 3.5M9.5 3.5L8.45001 5.25M9.5 3.5L8 2" class="accent-stroke" stroke="#C7FF24" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12.5 8V4C12.5 2.89543 13.3954 2 14.5 2H20.5C21.6046 2 22.5 2.89543 22.5 4V8C22.5 9.10457 21.6046 10 20.5 10H14.5C13.3954 10 12.5 9.10457 12.5 8Z" stroke="white" stroke-width="1.2" stroke-linecap="round"/>
              <path d="M2.5 20V16C2.5 14.8954 3.39543 14 4.5 14H10.5C11.6046 14 12.5 14.8954 12.5 16V20C12.5 21.1046 11.6046 22 10.5 22H4.5C3.39543 22 2.5 21.1046 2.5 20Z" stroke="white" stroke-width="1.2" stroke-linecap="round"/>
            </svg>
            <span>{{text('payment.exchange_btn')}}</span>
        </button>
        <button @click="interceptor(withdrawal)">
            <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.2122 14.8958H10.4889C9.26969 14.8958 8.27051 13.8691 8.27051 12.6041C8.27051 12.2283 8.58217 11.9166 8.95801 11.9166C9.33384 11.9166 9.64551 12.2283 9.64551 12.6041C9.64551 13.1083 10.0214 13.5208 10.4889 13.5208H12.2122C12.5697 13.5208 12.8538 13.2 12.8538 12.8058C12.8538 12.3108 12.7164 12.2375 12.4047 12.1275L9.64551 11.165C9.05884 10.9541 8.27051 10.5325 8.27051 9.18497C8.27051 8.03914 9.17802 7.09497 10.2872 7.09497H12.0105C13.2297 7.09497 14.2288 8.12164 14.2288 9.38664C14.2288 9.76247 13.9172 10.0741 13.5413 10.0741C13.1655 10.0741 12.8538 9.76247 12.8538 9.38664C12.8538 8.88247 12.478 8.46997 12.0105 8.46997H10.2872C9.92969 8.46997 9.64551 8.7908 9.64551 9.18497C9.64551 9.67997 9.783 9.75329 10.0947 9.86329L12.8538 10.8258C13.4405 11.0366 14.2288 11.4583 14.2288 12.8058C14.2288 13.9608 13.3213 14.8958 12.2122 14.8958Z" fill="white"/>
              <path d="M11.25 15.8125C10.8742 15.8125 10.5625 15.5008 10.5625 15.125V6.875C10.5625 6.49917 10.8742 6.1875 11.25 6.1875C11.6258 6.1875 11.9375 6.49917 11.9375 6.875V15.125C11.9375 15.5008 11.6258 15.8125 11.25 15.8125Z" fill="white"/>
              <path d="M11.2497 20.8541C5.81384 20.8541 1.39551 16.4358 1.39551 11C1.39551 5.56415 5.81384 1.14581 11.2497 1.14581C11.6255 1.14581 11.9372 1.45748 11.9372 1.83331C11.9372 2.20915 11.6255 2.52081 11.2497 2.52081C6.57467 2.52081 2.77051 6.32498 2.77051 11C2.77051 15.675 6.57467 19.4791 11.2497 19.4791C15.9247 19.4791 19.7288 15.675 19.7288 11C19.7288 10.6241 20.0405 10.3125 20.4163 10.3125C20.7922 10.3125 21.1038 10.6241 21.1038 11C21.1038 16.4358 16.6855 20.8541 11.2497 20.8541Z" fill="white"/>
              <path d="M20.4167 6.18748C20.0408 6.18748 19.7292 5.87581 19.7292 5.49998V2.52081H16.75C16.3742 2.52081 16.0625 2.20915 16.0625 1.83331C16.0625 1.45748 16.3742 1.14581 16.75 1.14581H20.4167C20.7925 1.14581 21.1042 1.45748 21.1042 1.83331V5.49998C21.1042 5.87581 20.7925 6.18748 20.4167 6.18748Z" class="accent-fill" fill="#C7FF24"/>
              <path d="M20.4164 1.14821C20.5905 1.14821 20.7647 1.21238 20.9022 1.34987C21.168 1.61571 21.168 2.05571 20.9022 2.32154L16.3189 6.90487C16.053 7.17071 15.613 7.17071 15.3472 6.90487C15.0814 6.63904 15.0814 6.19904 15.3472 5.93321L19.9305 1.34987C20.068 1.21238 20.2422 1.14821 20.4164 1.14821Z" class="accent-fill" fill="#C7FF24"/>
            </svg>

          <span>{{text('payment.withdrawal_btn')}}</span>
        </button>
    </div>
</template>

<script>
import { useModalsStore } from '@/store/stores/modals'

export default {
    name: "Payment",
    computed: {
        authInfo ({ $store: { state } }) {
            return state.authInfo
        },
        authToken ({ $store: { state } }) {
            return state.authToken
        },
        KYCPassed({ $store: { getters } }) {
          return getters.kycPassed
        }
    },
    mounted () {
      this.$store.dispatch('refreshUserNotifications')
      this.modalsStore = useModalsStore()

      this.$emit('update', this.topUp)
    },
    methods: {
        interceptor(fn) {
          fn()

          // if (!!this.KYCPassed) {
          //   fn()
          // } else {
          //   this.modalsStore.setModalName('RequiredKYCModal')
          // }
        },
        toExchange() {
          this.$router.push({ name: 'Exchange' })
        },
        withdrawal(){
            if (this.authInfo.is_withdrawal_allowed) {
                this.$router.push({name: "WalletWithdrawal"})
            } else {
                this.modalsStore.setModalName('RequiredKYCModal')
            }
        },
        topUp() {
            if (this.authInfo.is_topup_allowed) {
                this.$router.push({name: "WalletTopUp"})
            } else {
                this.modalsStore.setModalName('RequiredKYCModal')
            }
        }
    }    
}
</script>

<style lang="scss">
  .payment {
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: space-between;
  }
  .payment button {
    width: 50%;
    border-radius: 8px;
    background: var(--element-bg);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    gap: 8px;
  }
  .payment button:disabled {
    cursor: not-allowed;
  }
  .payment button span {
    color: #FFF;
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
  }

  .payment button svg {
    .accent-fill {
      fill: var(--accent-bg);
    }
    .accent-stroke {
      stroke: var(--accent-bg);
    }
  }

  @media (max-width: 920px) {
    .payment button {
      padding: 12px;
      border-radius: 12px;
      gap: 4px;
      flex-direction: column;
      font-size: 14px;
      background: var(--layout-bg);
    }
  }
</style>